import { ArticleSection } from "./articleSection.descriptor";
import { BlockWithTitle } from "./blocWithTitle.descriptor";
import { ContactForm } from "./contactForm.descriptor";
import { DescriptionBlock } from "./descriptionBlock.descriptor";
import { GeographicMap } from "./geographicMap.descriptor";
import { Iframe } from "./iframe.descriptor";
import { Mailto } from "./mailto.descriptor";
import { PresentationBlock } from "./presentationBlock.descriptor";
import { PresentationCard } from "./presentationCard.descriptor";
import { PresentationBox } from "./presentationBox.descriptor";
import { Subpage } from "./subpage.descriptor";
import { SubpageSearch } from "./subpageSearch.descriptor";
import { TextBlockWithTitle } from "./textBlockWithTitle.descriptor";
import { Trombinoscope } from "./trombinoscope.descriptor";
import { DescriptionCardWithLogo } from "./descriptionCardWithLogo.descriptor";
import { TabsComponent } from "./tabsComponent.descriptor";
import { HorizontalInfos, HorizontalInfosItem, } from "./horizontalInfos.descriptor";
import { ProductBlock } from "./productBlock.descriptor";
import { ContactBlock } from "./contactBlock.descriptor";
import { CardItem, CardsGrid } from "./cardsGrid.descriptor";
import { AutoScrollingInfoItem, AutoScrollingInfos, } from "./autoScrollingInfos.descriptor";
import { SkillBox, SkillsTabPanelComponent, } from "./skillsTabPanelComponent.descriptor";
import { DescriptionSection, DescriptionSectionItem, } from "./descriptionSection.descriptor";
import { DocaposteSection } from "./docaposteSection.descriptor";
import { ArticleCardList, ArticleCardListItem, } from "./articleCardList.descriptor";
export default [
    ArticleSection,
    PresentationBox,
    Trombinoscope,
    BlockWithTitle,
    TextBlockWithTitle,
    DescriptionBlock,
    DescriptionCardWithLogo,
    PresentationBlock,
    PresentationCard,
    TabsComponent,
    Subpage,
    GeographicMap,
    SubpageSearch,
    ContactForm,
    Mailto,
    Iframe,
    HorizontalInfos,
    HorizontalInfosItem,
    ProductBlock,
    ContactBlock,
    CardsGrid,
    CardItem,
    AutoScrollingInfos,
    AutoScrollingInfoItem,
    SkillsTabPanelComponent,
    SkillBox,
    DescriptionSection,
    DescriptionSectionItem,
    DocaposteSection,
    ArticleCardList,
    ArticleCardListItem,
];
